import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Bs4Dialog from '../Bs4Components/Bs4Dialog';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';

import { ChromePicker } from 'react-color'

import Checkbox from '@mui/material/Checkbox';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import Bs4Popper from '../Bs4Components/Bs4Popper';

import Bs4MainDispatch from '../Bs4MainDispatch';
import { toDateTimeStamp } from '../Bs4Components/Bs4Utils'
import Bs4I18N from '../Bs4I18N';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';
import {EventEmitArray} from '../Bs4Components/Bs4Utils'

export const UXTEMPLATE = 'uxTemplate';
export const UXTEMPLATE_NEW = 'uxtemplate_new';
export const SmallScreenContext = React.createContext({});

let dateTimeStamp = toDateTimeStamp(new Date());
let currentUxTemplate = null;

const eventEmitUxTemplate = new EventEmitArray();

const setUxTemplateUpdate = (types, uxTemplate) => {
  dateTimeStamp = toDateTimeStamp(new Date());  
  eventEmitUxTemplate.trigger(types, { dateTimeStamp, setUxTemplateUpdate, currentUxTemplate: uxTemplate})
}

export const useStateUxTemplate = (types) => {
  const [value, setValue] = React.useState({ dateTimeStamp, setUxTemplateUpdate, currentUxTemplate});

  React.useEffect(() => {
    if (!types) types = 'DEFAULT TYPE';
    eventEmitUxTemplate.on(types, setValue);
    return () => eventEmitUxTemplate.off(setValue);
  }, [types, setValue])

  // console.log('...useStateUxTemplate...', types,value)
  return value;
}

export class Bs4UxTemplates {
  static uxTemplates = [];
  static uxMainId = null;
  static uxMainTemplate = null  
  
  static setUxTemplates(uxTemplates, uxMainId) {
    if (!Array.isArray(uxTemplates)) {
      console.log('=== setUxTemplates === uxTemplates not array', uxTemplates)
      return;
    }

    console.log('...setUxTemplates...', uxTemplates, uxMainId);
    Bs4UxTemplates.uxTemplates = uxTemplates.map(uxTemplate => {
      const ut = {...uxTemplate};
      try {
        ut.body = JSON.parse(uxTemplate.body);
      } catch(error) {
        console.log('=== setUxTemplates =1=', uxTemplate)
        console.log('=== setUxTemplates =2=', error)
        ut.body = {};
      }
      return ut;
    })
    Bs4UxTemplates.uxMainId = uxMainId;
    Bs4UxTemplates.uxMainTemplate = this.getUxTemplate(0, 0, uxMainId);
    console.log('=== setUxTemplates =uxMainId= ', uxMainId)
    // console.log('=== setUxTemplates =UX= ', {...Bs4UxTemplates.uxTemplates}, {...Bs4UxTemplates.uxMainTemplate})
  }

  static updateUxTemplates(uxTemplates) {
    if (!Array.isArray(uxTemplates)) {
      // console.log('=== setUxTemplates === uxTemplates not array', uxTemplates)
      return;
    }

    const uxTemplateObject = {};
    uxTemplates.forEach(ux => uxTemplateObject[ux.id] = ux)

    Bs4UxTemplates.uxTemplates.forEach(ux => {
      if (ux.temporary) return;      
      const newUx = uxTemplateObject[ux.id];
      if (newUx) {        
        delete uxTemplateObject[ux.id];
        try {
          // 2024-05-15
          const body = JSON.parse(newUx.body);
          ux.body = deepmerge(ux.body, body);
        } catch(error) {
          console.log('=== uxTemplateObject =1=', newUx)
          console.log('=== uxTemplateObject =2=', error)
          return;
        }
        ux.name = newUx.name;
        ux.class = newUx.class;
        ux.pagetype = newUx.pagetype;
        ux.default = newUx.default;
      }
    })

    //Add new ux
    for (const [key, ux] of Object.entries(uxTemplateObject)) {
      try {
        ux.body = JSON.parse(ux.body);
      } catch(error) {
        console.log('=== uxTemplateObject =1=', ux)
        console.log('=== uxTemplateObject =2=', error)
        return;
      }
      Bs4UxTemplates.uxTemplates.push(ux)
    }

    console.log('=== updateUxTemplates =UX= ', {...Bs4UxTemplates.uxTemplates}, {...uxTemplates})
  }

  static getUxTemplates(uxClass, pagetype) {
    return Bs4UxTemplates.uxTemplates.filter(ux => {
      if (String(ux.class) !== String(uxClass)) return false;
      if (String(ux.pagetype) !== String(pagetype) && String(ux.class) !== '0' && String(ux.class) !== '216') return false;
      return true;
    });
  }

  //- id klasy dla jakich elementów jest layout: 0- ustawienia dla okna głównego (całego programu), 216- ustawienie dla kartoteki, 189- ustawienie dla typu strony
  static getUxTemplate(uxClass, pagetype, id) {
    return Bs4UxTemplates.uxTemplates.find(ux => {
      //console.log('...getUxTemplate.0.', String(uxClass), String(pagetype), String(id))
      //console.log('...getUxTemplate.1.', String(ux.class), String(ux.pagetype), String(ux.id))
      //console.log('...getUxTemplate.1.', (String(ux.class) !== String(uxClass)))
      if (String(ux.class) !== String(uxClass)) return false;
      //console.log('...getUxTemplate.1.', (String(ux.pagetype) !== String(pagetype)))
      if (String(ux.pagetype) !== String(pagetype) && String(ux.class) !== '0' && String(ux.class) !== '216') return false;
      //console.log('...getUxTemplate.1.', (String(ux.id) !== String(id)))
      if (String(ux.id) !== String(id)) return false;
      //console.log('...getUxTemplate.1.', )
      return true;
    });
  }

  static getDefaultUxTemplate(uxClass, pagetype) {
    return Bs4UxTemplates.uxTemplates.find(ux => {
      if (String(ux.class) !== String(uxClass)) return false;
      if (String(ux.pagetype) !== String(pagetype) || String(ux.class) === 216) return false;
      if (ux.default !== 'y') return false;
      return true;
    });
  }

  static addUxTemplate(uxTemplate) {
    Bs4UxTemplates.uxTemplates.push(uxTemplate);    
  }

  static deleteUxTemplate(uxTemplate) {
    //console.log('...deleteUxTemplate.0.', [...Bs4UxTemplates.uxTemplates])
    const index = Bs4UxTemplates.uxTemplates.findIndex(ux => {      
      if (String(ux.class) !== String(uxTemplate.class)) return false;
      if (String(ux.pagetype) !== String(uxTemplate.pagetype)) return false;
      if (String(ux.id) !== String(uxTemplate.id)) return false;
      return true;
    });
    
    if (index >= 0) Bs4UxTemplates.uxTemplates.splice(index, 1);    
  }

  static addedValueUxTemplate = null;
  static addedValue(id) {
    const addedValueUxTemplate = Bs4UxTemplates.addedValueUxTemplate;
    Bs4UxTemplates.addedValueUxTemplate = null;
    if (addedValueUxTemplate) addedValueUxTemplate(id);
    else console.log('...Bs4UxTemplates...addedValue...empty id:', id);
  }
}

export const getRgbColor = (rgb) => {
  try {
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
  } catch(error) {
    console.log(error)
    return 'rgba(0, 0, 0, 1)';
  }
}

const getPositiveNumber = (value) => {    
  let v = parseFloat(value);
  if (isNullOrNaN(v)) return null;
  return Math.max(0, v);
}

export const isPercent = (value) => {
  return String(value).includes('%');
}

export const getBs4Style = (bs4StyleStr, empty) => {
  try {
    let bs4Style = JSON.parse(bs4StyleStr)
    if (bs4Style && typeof bs4Style === 'object' && !Array.isArray(bs4Style)) return bs4Style;
  } catch(error) {}
  return empty || null;
}

export const getBoxSx = (value, theme, filter) => {  

  if (!value) return {};

  if (typeof value === 'string' || value instanceof String) {
    try {
      value = JSON.parse(value)
      if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    } catch(error) {
      return {};
    }
  }
  
  const sx = {...value};

  for (const [key, value] of Object.entries(sx)) {
    if (typeof value === "undefined" || value === null || value === '') delete sx[key]
    if (!isNullOrNaN(value)) sx[key] = parseFloat(value);
  }

  if (Array.isArray(filter)) for (const key of Object.keys(sx)) if (!filter.includes(key)) delete sx[key];

  if (sx.borderWidth) sx.borderStyle = 'solid';

  //widthMargin - szerokość, jeżeli % zostanie pomniejszona o marginesy lewy i prawy
  if (sx.widthMargin) {    
    sx.width = sx.widthMargin;
    delete sx.widthMargin;
    if (isPercent(sx.width) && sx.margin) {
      if (!isNullOrNaN(sx.margin)) sx.margin = theme.spacing(sx.margin);
      sx.width = `calc(${sx.width} - ${sx.margin} - ${sx.margin})`;
    }     
  }

  if (!isNullOrNaN(sx.elevation)) {
    sx.boxShadow = theme.shadows[value.elevation];
    delete sx.elevation;
  }

  return sx;
}

export const getBoxStyle = (value, theme, filter) => {  
  const sx = getBoxSx(value, theme, filter);
  if (!isNullOrNaN(sx.margin)) sx.margin = theme.spacing(sx.margin);
  if (!isNullOrNaN(sx.padding)) sx.padding = theme.spacing(sx.padding);
  if (!isNullOrNaN(sx.borderWidth)) sx.borderWidth = parseFloat(sx.borderWidth)+'px';
  if (!isNullOrNaN(sx.borderRadius)) sx.borderRadius = parseFloat(sx.borderRadius) * theme.shape.borderRadius+'px';
  if (!isNullOrNaN(sx.minHeight)) sx.minHeight = parseFloat(sx.minHeight)+'px';
  if (!isNullOrNaN(sx.width)) sx.width > 1 ? sx.width = parseFloat(sx.width)+'px' : sx.width = (parseFloat(sx.width) * 100)+'%';
  if (!isNullOrNaN(sx.height)) sx.height > 1 ? sx.height = parseFloat(sx.height)+'px' : sx.height = (parseFloat(sx.height) * 100)+'%';
  return sx;
}

export const backgroundGrille = {
  backgroundImage: 'linear-gradient(45deg, #dddddd 25%, transparent 25%), linear-gradient(-45deg, #dddddd 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #dddddd 75%), linear-gradient(-45deg, transparent 75%, #dddddd 75%)',
  backgroundSize: '20px 20px',
  backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
}

const ViewBoxGrille = (props) => {
  const handleClick = (event) => {
    event?.stopPropagation();
    props.onClick && props.onClick(event);
  }

  return (
    <Box sx={{width: '100%', height: 25, ...backgroundGrille}} onClick={handleClick}>
      <Box sx={{width: '100%', height: '100%', backgroundColor: props.color}}/>
    </Box>
  )
}

export const ViewColorBox = (props) => {
  const theme = useTheme();
  const [sxBoxGrill, setSxBoxGrill] = React.useState({});

  const handleClick = (event) => {
    event?.stopPropagation();
    if (props.onClick) props.onClick(event);
  }

  const handleShowGrille = (event) => {    
    if (event.type === 'mouseenter') setSxBoxGrill(backgroundGrille);
    else setSxBoxGrill({});      
  }    
  
  const icon = "fa-solid fa-paintbrush";

  //const sxBoxValue =  getSxFiltered(props.value, theme)
  const sxBoxValue = getBoxSx(props.value, theme)

  return (
    <Box 
      sx={{p: 2, width: '100%', overflow: 'hidden', minWidth: 200, ...sxBoxGrill}} 
      onMouseEnter={handleShowGrille}
      onMouseLeave={handleShowGrille}    
      onClick={handleClick}
    >             
      <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2} px={2} sx={sxBoxValue}>
        <i className={icon}></i>
        <span>{'Text'}</span>
      </Stack>                  
    </Box>
  )
}

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box role="tabpanel" hidden={value !== index} {...other}>
      {value === index && 
        <Box>
          {children}
        </Box>
      }
    </Box>
  );
}

export const UxAccordion = (props) => {
  const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
  
  const handleReset = (event) => {
    event.stopPropagation();
    if (props.onReset) props.onReset()
    setUxTemplateUpdate(props.types);
  }

  //"fa-solid fa-trash"
  const resetIcon = 'fa-solid fa-arrows-rotate';

  return (
    <Accordion 
    //disableGutters 
      expanded={props.label === props.expanded} 
      onChange={props.onChange(props.label)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
        <Stack direction='row' justifyContent='flex-start'  alignItems="center" spacing={1}>
          <Typography>{props.label}</Typography>
          <IconButton edge='start' onClick={handleReset}>
            <i className={resetIcon}/>
          </IconButton>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{p: 0}}>              
        {props.children}
      </AccordionDetails>
    </Accordion>
  )
}

export class UxTemplateEditor {
  text_Visual_editor = Bs4I18N.getTT("Visual Editor", 'Edytor wizualny', 'UxTemplateEditor');
  text_Set_as_default = Bs4I18N.getTT("Set as default", 'Ustaw jako domyślny', 'UxTemplateEditor');
  text_Template = Bs4I18N.getTT("Template", 'Template', 'UxTemplateEditor');
  text_New = Bs4I18N.getTT("New", 'Nowy', 'UxTemplateEditor');
  text_Save = Bs4I18N.getTT("Save", 'Zapisz', 'UxTemplateEditor');
  text_Save_as = Bs4I18N.getTT("Save as", 'Zapisz jako', 'UxTemplateEditor');
  text_Rename = Bs4I18N.getTT("Rename", 'Zmień nazwę', 'UxTemplateEditor');  
  text_Delete = Bs4I18N.getTT("Delete", 'Usuń', 'UxTemplateEditor');
  text_Cancel = Bs4I18N.getTT("Cancel", 'Anuluj', 'UxTemplateEditor');
  text_Delete_uxTemplate = Bs4I18N.getTT("Remove uxTemplate ?", 'Usunąć uxTemplate ?', 'UxTemplateEditor');  
  text_Default = Bs4I18N.getTT("Default", 'Domyślny', 'UxTemplateEditor');
  text_Delete_uxTemplate = Bs4I18N.getTT("Remove uxTemplate ?", 'Usunąć uxTemplate ?', 'UxTemplateEditor');  
  text_name_already_exists = Bs4I18N.getTT("The name already exists.", 'Nazwa już istnieje.', 'UxTemplateEditor');
  text_Enter_a_name = Bs4I18N.getTT("Enter a name", 'Wpisz nazwę', 'UxTemplateEditor');  
  text_Temporary = Bs4I18N.getTT("Temporary", 'Tymczasowy', 'UxTemplateEditor');  
  text_Page = Bs4I18N.getTT("Page", 'Strona', 'UxTemplateEditor');  
  

  constructor(context) {
    this.context = context;
  }

  ViewCssLabel = (props) => {
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    
    
    const onClickTrassh = (event) => {      
      event.stopPropagation();
      delete props.value?.[props.name];
      // props.value.deleted = new Date().toISOString();
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
      
    if (props.hidden) return null;
    
    //<i class="fa-solid fa-delete-left"></i>
    //<i class="fa-solid fa-trash-can"></i>
    //"fa-solid fa-trash"
    //<i class="fa-solid fa-xmark"></i>
    //<i class="fa-solid fa-circle-xmark"></i>

    //<i class="fa-solid fa-play"></i>
    return (
      <Stack direction="row" justifyContent='flex-start' alignItems="center" spacing={2}>
        <span>{props.title || props.name}</span>        
        <i className="fa-solid fa-trash" style={{display: (props.name in (props.value || {})) ? 'inline' : 'none'}} onClick={onClickTrassh}/>
      </Stack>
    )
  }

  ViewCssTime = (props) => {
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);

    const handleChange = (newValue, context) => {
      if (!newValue) delete props.value?.[props.name];
      else props.value[props.name] = Bs4Utils.toTime(newValue);
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }  

    const getValue = () => {
      const value = Bs4Utils.getValidDateFromTime(props.value?.[props.name]);
      if (!value) return null;
      return value;
    }

    if (props.hidden) return null;

    //console.log('...CssTime...', props.value?.[props.name], Bs4Utils.getValidDateFromTime(props.value?.[props.name]))
        
    const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();
      
    return (
      <LocalizationProvider 
        dateAdapter={AdapterDateFns}  
        adapterLocale={xx}         
        localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <TimePicker
          fullWidth 
          label={<cssField.ViewCssLabel {...props}/>}
          value={getValue()}
          onChange={handleChange}
        />      
      </LocalizationProvider>
    )
  }

  ViewCssText = (props) => {
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    const [selection, setSelection] = React.useState(null);

    const handleChange = (event) => {
      setSelection({target: event.target, start: event.target.selectionStart, end: event.target.selectionEnd})
      const value = event.target.value;
      if (!value) delete props.value?.[props.name];
      else props.value[props.name] = value;
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }  

    if (props.hidden) return null;

    React.useEffect(() => {
      if (selection) {
        selection.target.setSelectionRange(selection.start, selection.end)
        setSelection(null);
      }
    }, [selection])
      
    return (
      <TextField
        inputProps={props.inputProps}
        fullWidth 
        label={<cssField.ViewCssLabel {...props}/>}
        value={props.value?.[props.name] || ''} 
        onChange={handleChange}
      />
    )
  }
  
  ViewCssNumber = (props) => {
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    
    const handleChange = (event) => {
      const value = getPositiveNumber(event.target.value);
      if (isNullOrNaN(value)) delete props.value?.[props.name];
      else props.value[props.name] = value;
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    const getValue = () => {
      const value = parseFloat(props.value?.[props.name]);
      if (isNullOrNaN(value)) return '';      
      return value;
    }
  
    if (props.hidden) return null;

    return (
      <Stack direction='row' justifyContent='flex-start' alignItems='flex-end' spacing={0.5} sx={{width: '100%'}}>
        <TextField 
          inputProps={props.inputProps}
          fullWidth 
          label={<cssField.ViewCssLabel {...props}/>}
          type={'number'} 
          value={getValue()} 
          onChange={handleChange}
        />      
      </Stack>
    )
  }
  
  ViewCssShadow = (props) => {
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    const theme = useTheme();
    
    const handleChange = (event) => {
      let value = parseInt(event.target.value);    
      
      if (value || value === 0) {
        if (value < 0) value = 0;
        if (value >= theme.shadows.length) value = theme.shadows.length - 1;
        props.value[props.name] = value;
      }
      else delete props.value?.[props.name];
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    const getValue = () => {
      const value = parseFloat(props.value?.[props.name]);
      if (isNullOrNaN(value)) return '';
      return value;
    }
  
    if (props.hidden) return null;
  
    return (
      <TextField 
        fullWidth 
        label={<cssField.ViewCssLabel {...props}/>} 
        type={'number'} 
        value={getValue()} 
        onChange={handleChange}
      />
    )
  }
  
  ViewCssColor = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      event?.stopPropagation();
      setAnchorEl(event.currentTarget, );
    }
    
    const handleClose = (event) => {
      event?.stopPropagation();
      setAnchorEl(null)
    }

    const handleChange = (newColor) => {
      const color = getRgbColor(newColor.rgb);
      if (color) props.value[props.name] = color;
      else delete props.value?.[props.name];
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
      // const cl = Bs4Utils.getColorLuminosity(color);
      // console.log('...ViewCssColor...', color, cl);
    }
      
    if (props.hidden) return null;
    
    return (
      <Box flex={1}>
        <FormLabel><cssField.ViewCssLabel {...props}/></FormLabel>
        <ViewBoxGrille color={props.value?.[props.name]} onClick={handleClick}/>
        <Bs4Popper anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <ChromePicker color={props.value?.[props.name]} onChange={handleChange} onChangeComplete={handleChange}/>
        </Bs4Popper>
      </Box>
    )
  }
  
  ViewCssSelect = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);

    const handleChange = (event, newValue) => {
      if (newValue) props.value[props.name] = newValue;
      else delete props.value?.[props.name];
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    if (props.hidden) return null;
  
    return (
      <Autocomplete
        fullWidth
        //disablePortal
        value={props.value?.[props.name] || null}
        onChange={handleChange}
        options={props.options}
        renderInput={(params) => <TextField {...params} label={<cssField.ViewCssLabel {...props}/>}/>}
      />
    )
  }

  ViewCssTypography = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);
    const theme = useTheme();    
    const options = React.useMemo(() => {
      const keys = []
      for (const [key, value] of Object.entries(theme.typography)) {
        if (value.fontFamily) keys.push(key)
      }
      return keys;
    }, [theme]);
      
    const handleChange = (event, newValue) => {
      if (newValue) props.value[props.name] = newValue;
      else delete props.value?.[props.name];
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    if (props.hidden) return null;
  
    return (
      <Autocomplete
        fullWidth

        value={props.value?.[props.name] || null}
        onChange={handleChange}
        options={options}
        renderInput={(params) => {
          return (            
            <Stack direction="row" justifyContent="flex-start" alignItems='baseline' spacing={1} sx={{width: '100%'}}>            
              <TextField {...params} label={<cssField.ViewCssLabel {...props}/>}/>
              <Typography variant={params.inputProps.value}>{params.inputProps.value}</Typography>
            </Stack>
        )}}

        renderOption={(props, option, { selected }) => (
          <Typography {...props} key={option} variant={option}>
            {option}
          </Typography>
        )}
      />
    )
  }
  
  ViewCssMultiple = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);

    const handleChange = (event, newValue) => {
      if (newValue) props.value[props.name] = newValue;
      else delete props.value?.[props.name];
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    if (props.hidden) return null;
  
    return (
      <Autocomplete
        fullWidth 
        multiple
        disableCloseOnSelect
        value={props.value?.[props.name] || []}
        onChange={handleChange}
        options={props.options || []}
        getOptionLabel={option => option?.name}
        isOptionEqualToValue={(option, value) => option.id == value.id}
        renderInput={(params) => <TextField {...params} label={<cssField.ViewCssLabel {...props}/>}/>}      
        renderOption={(props, option, { selected }) => (
          <Box {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip                
              {...getTagProps({index})} 
              key={option.id}
              label={option.name}            
            />
          ))
        }
      />
    )
  }
 
  ViewCssCheckboxes = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);    
    const theme = useTheme();    
    const handleChange = (event, checked, option) => {
      if (checked) {
        if (! Array.isArray(props.value?.[props.name])) props.value[props.name] = [];
        if (! props.value[props.name].find(id => id === option.id)) props.value[props.name].push(option.id);
      }
      else props.value[props.name] = props.value[props.name].filter(id => id !== option.id);
      setUxTemplateUpdate(props.types, this.updateUxTemplate());
    }
  
    const isChecked = (option) => {
      if (! Array.isArray(props.value?.[props.name])) return false;
      return props.value[props.name].includes(option.id);
    }
  
    if (props.hidden) return null;
  
    return (
      <FormControl>
        <FormLabel><cssField.ViewCssLabel {...props}/></FormLabel>
        <FormGroup>
          {(props.options || []).map((option, index) => (
            <FormControlLabel 
              key={option.id}
              control={<Checkbox checked={isChecked(option)} onChange={(e, v) => handleChange(e, v, option)}/>}
              label={option.name}
            />  
          ))}
        </FormGroup>
      </FormControl>
    )
  }
  
  ViewCssCheckbox = (props) => {    
    const cssField = this;
    const {setUxTemplateUpdate} = useStateUxTemplate(props.types);

    const handleChange = (event, checked) => {      
      props.value[props.name] = checked;
      setUxTemplateUpdate(props.types, this.updateUxTemplate());      
    }
    
    if (props.hidden) return null;

    return (
      <Stack direction="row" justifyContent='flex-start' alignItems="center" spacing={1}>                        
        <FormLabel><cssField.ViewCssLabel {...props}/></FormLabel>
        <Checkbox checked={Boolean(props.value?.[props.name])} onChange={handleChange}/>
      </Stack>
    )
  }

  ViewUxTemplateNameList = (props) => {
    const uxEditor = this;
    const {dateTimeStamp, setUxTemplateUpdate} = useStateUxTemplate(props.types);    

    const options = React.useMemo(() => {            
      if (!props.uxTemplate) return [];
      return Bs4UxTemplates.getUxTemplates(props.uxTemplate.class, props.uxTemplate.pagetype).filter(ux => !ux.temporary);
    }, [dateTimeStamp, props.uxTemplate])

    const [anchorEl, setAnchorEl] = React.useState(null);    
    
    const handleClick = (event) => {
      event?.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
    };

    const handleMenuItemClick = (event, uxTemplate) => {
      if (props.setUxTemplate) props.setUxTemplate(uxTemplate.id);
      setUxTemplateUpdate(props.types);
      handleClose(event);
    }

    if (options?.length === 1 && options[0].id === props.uxTemplate.id) return null;
    if (options?.length < 1) return null;

    return (
      <Box>
        <IconButton onClick={handleClick}><ArrowDropDownIcon/></IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map(uxTemplate => {          
          const typeUx = Boolean(uxTemplate.default === 'y') ? uxEditor.text_Default : Boolean(uxTemplate.temporary) ? uxEditor.text_Temporary : '';
          const dateTimeStamp = Boolean(uxTemplate.body.dateTimeStamp) ? uxTemplate.body.dateTimeStamp : '';
          return (
          <MenuItem key={uxTemplate.id} value={uxTemplate.id} selected={props.uxTemplate.id === uxTemplate.id} onClick={(event) => handleMenuItemClick(event, uxTemplate)}>
            <ListItemText primary={uxTemplate.name} secondary={dateTimeStamp+' '+typeUx}/>
          </MenuItem>
        )})}
        </Menu>
      </Box>
    );
  }

  isNameWrong = (name) => {
    if (!name) return this.text_Enter_a_name;
    const ux = Bs4UxTemplates.uxTemplates.find(ux => {
      return name === ux.name;
    });

    if (Boolean(ux)) return this.text_name_already_exists;
    return null;
  }

  ViewUxTemplateSaveDelete = (props) => {
    const uxEditor = this;
    const {dateTimeStamp, setUxTemplateUpdate} = useStateUxTemplate(props.types);    
    const uxTemplate = React.useMemo(() => {
      if (props.getUxTemplate) return props.getUxTemplate();
      return {name: '', body: {}};
    }, [dateTimeStamp, props.getUxTemplate])

    const [anchorEl, setAnchorEl] = React.useState(null);
    const refButtonGroup = React.useRef(null)
    const [openDelete, setOpenDelete] = React.useState(false);    
    const [saveTitle, setSaveTitle] = React.useState(null);    
    const [openSaveAs, setOpenSaveAs] = React.useState(false);    
    const [openRename, setOpenRename] = React.useState(false);    
    const [newName, setNewName] = React.useState('');    
    const errorName = React.useMemo(() => this.isNameWrong(newName), [newName, dateTimeStamp]) ;
    
    // console.log('...ViewUxTemplateSaveDelete...', uxTemplate, props.types);
    
    const handleNew = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
      if (uxTemplate.temporary) Bs4UxTemplates.deleteUxTemplate(uxTemplate)
      if (props.setUxTemplate) props.setUxTemplate(UXTEMPLATE_NEW);
      setUxTemplateUpdate(props.types);
    }

    const handleSave = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
      
      if (uxTemplate.temporary) {
        setNewName('')
        setSaveTitle(this.text_Save);
        setOpenSaveAs(true);
        return;
      }
      
      uxTemplate.body.dateTimeStamp = toDateTimeStamp(new Date());
      const details = {
        uxId: uxTemplate.id,
        uxName: uxTemplate.name,
        uxClass: uxTemplate?.class,
        uxPagetype: uxTemplate.pagetype,
        uxBody: JSON.stringify(uxTemplate.body),
        operation: 1,
        currCardViewId: props.bs4KartotekaId,
        currOptionId: props.optionId,
      }
  
      Bs4UxTemplates.addedValueUxTemplate = (id) => {
        console.log('...Bs4UxTemplates...Save... id:', id);
        if (id) uxTemplate.id = id;
        setUxTemplateUpdate(props.types);
      }

      Bs4MainDispatch.commandParser('Bs4SaveLayout', details, props.bs4KartotekaId);
    }

    const handleSaveAs = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
      setNewName(uxTemplate.name)
      setSaveTitle(this.text_Save_as);
      setOpenSaveAs(true);
    }

    const handleSaveAsOk = (event) => {      
      setOpenSaveAs(false);
      uxTemplate.body.dateTimeStamp = toDateTimeStamp(new Date());      

      const details = {
        uxId: uxTemplate.temporary ? null : uxTemplate.id,
        uxName: uxTemplate.name,
        uxNewName: newName,
        uxClass: uxTemplate?.class,
        uxPagetype: uxTemplate.pagetype,
        uxBody: JSON.stringify(uxTemplate.body),
        operation: 2,
        currCardViewId: props.bs4KartotekaId,
        currOptionId: props.optionId,
      }
  
      Bs4UxTemplates.addedValueUxTemplate = (id) => {
        console.log('...Bs4UxTemplates...SaveAs... id:', id, uxTemplate.id, props);
        if (id === uxTemplate.id) {
          console.log('...Bs4UxTemplates...SaveAs... error id===newId:', id, uxTemplate.id);
          return;
        }
        if (!Boolean(id)) {
          console.log('...Bs4UxTemplates...SaveAs... error no id:', id, uxTemplate.id);
          return;
        }

        const newUxTemplate = JSON.parse(JSON.stringify(uxTemplate)) 
        newUxTemplate.id = id;
        delete newUxTemplate.temporary
        newUxTemplate.name = newName;
        newUxTemplate.default = 'n';
        Bs4UxTemplates.addUxTemplate(newUxTemplate);
        if (uxTemplate.temporary) Bs4UxTemplates.deleteUxTemplate(uxTemplate);
        props.setUxTemplate(newUxTemplate.id);
        console.log('...Bs4UxTemplates...SaveAs... :', Bs4UxTemplates.uxTemplates, newUxTemplate, uxTemplate);
        setUxTemplateUpdate(props.types);
      }

      Bs4MainDispatch.commandParser('Bs4SaveLayout', details, props.bs4KartotekaId);      
    }

    const handleRename = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
      setNewName(uxTemplate.name)
      setOpenRename(true);      
    }

    const handleRenameOk = (event) => {
      setOpenRename(false);
      uxTemplate.body.dateTimeStamp = toDateTimeStamp(new Date());
      const details = {
        uxId: uxTemplate.id,
        uxName: uxTemplate.name,
        uxNewName: newName,
        uxClass: uxTemplate?.class,
        uxPagetype: uxTemplate.pagetype,
        //uxBody: JSON.stringify(uxTemplate.body),
        operation: 3,
        currCardViewId: props.bs4KartotekaId,
        currOptionId: props.optionId,
      }
  
      Bs4UxTemplates.addedValueUxTemplate = (id) => {
        console.log('...Bs4UxTemplates...Rename... id:', id);
        uxTemplate.id = id;
        uxTemplate.name = newName;
        setUxTemplateUpdate(props.types);
      }

      Bs4MainDispatch.commandParser('Bs4SaveLayout', details, props.bs4KartotekaId);
    }

    const handleSetDefault = (event) => {
      event?.stopPropagation();
      setAnchorEl(null);
      uxTemplate.body.dateTimeStamp = toDateTimeStamp(new Date());
      const details = {
        uxId: uxTemplate.id,
        uxName: uxTemplate.name,
        uxClass: uxTemplate?.class,
        uxPagetype: uxTemplate.pagetype,
        default: 'y',
        operation: 4,
        currCardViewId: props.bs4KartotekaId,
        currOptionId: props.optionId,
      }
  
      Bs4UxTemplates.addedValueUxTemplate = (id) => {
        console.log('...Bs4UxTemplates...setDefault... id:', id);
        if (id) uxTemplate.id = id;
        uxTemplate.default = 'y';
        setUxTemplateUpdate(props.types);
      }

      Bs4MainDispatch.commandParser('Bs4SaveLayout', details, props.bs4KartotekaId);
    }

    const handleDelete = (event) => {
      event?.stopPropagation();
      setOpenDelete(true)
      setAnchorEl(null);
    }    

    const handleDeleteOk = (event) => {
      setOpenDelete(false);
      uxTemplate.body.dateTimeStamp = toDateTimeStamp(new Date());
      const details = {
        uxId: uxTemplate.id,
        uxName: uxTemplate.name,
        uxClass: uxTemplate?.class,
        uxPagetype: uxTemplate.pagetype,
        //uxBody: JSON.stringify(uxTemplate.body),
        operation: 5,
        currCardViewId: props.bs4KartotekaId,
        currOptionId: props.optionId,
      }
  
      Bs4UxTemplates.addedValueUxTemplate = (id) => {
        console.log('...Bs4UxTemplates...Delete... id:', id);
        Bs4UxTemplates.deleteUxTemplate(uxTemplate);
        if (props.setUxTemplate) props.setUxTemplate(-1);
        setUxTemplateUpdate(props.types);
      }

      Bs4MainDispatch.commandParser('Bs4SaveLayout', details, props.bs4KartotekaId);
    }    

    const handleChangeName = (event) => {
      setNewName(event.target.value);
    }    

    const handleClick = (event) => {
      event?.stopPropagation();
      setAnchorEl(refButtonGroup.current)
    }

    const handleClose = (event) => {
      event?.stopPropagation();
      setAnchorEl(null)
    }
    
    //console.log('...Template... ...:', uxTemplate.id, uxTemplate.name, uxTemplate.lastUpdate);

    return (
      <ButtonGroup ref={refButtonGroup} sx={{my:0.5}}>
        <Button onClick={handleClick}>
          {uxEditor.text_Template}
          <KeyboardArrowDownIcon/>
        </Button>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} variant='menu'>
          <MenuItem onClick={handleNew}>{uxEditor.text_New}</MenuItem>
          <MenuItem onClick={handleSave}>{uxEditor.text_Save}</MenuItem>
          <MenuItem onClick={handleSaveAs}>{uxEditor.text_Save_as}</MenuItem>
          <MenuItem onClick={handleRename} disabled={Boolean(uxTemplate.temporary)}>{uxEditor.text_Rename}</MenuItem>
          <MenuItem onClick={handleDelete} disabled={Boolean(uxTemplate.temporary)}>{uxEditor.text_Delete}</MenuItem>
          <MenuItem onClick={handleSetDefault} disabled={Boolean(uxTemplate.body.main) || !Boolean(uxTemplate.name) || uxTemplate.default === 'y'}>{uxEditor.text_Set_as_default}</MenuItem>
          {/* <MenuItem onClick={handleTest}>{'Test'}</MenuItem> */}
        </Menu>

        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>{uxEditor.text_Delete_uxTemplate}</DialogTitle>
          <DialogContent>
            <Typography>{uxTemplate.name}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDelete(false)}>{uxEditor.text_Cancel}</Button>
            <Button onClick={handleDeleteOk} autoFocus>{uxEditor.text_Delete}</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openSaveAs} onClose={() => setOpenSaveAs(false)}>
          <DialogTitle>{saveTitle}</DialogTitle>
          <DialogContent>                  
            <TextField value={newName} onChange={handleChangeName} error={Boolean(errorName)} helperText={errorName}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {setOpenSaveAs(false);}}>{uxEditor.text_Cancel}</Button>
            <Button onClick={handleSaveAsOk} disabled={Boolean(errorName)}>{uxEditor.text_Save}</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openRename} onClose={() => setOpenRename(false)}>
          <DialogTitle>{uxEditor.text_Rename}</DialogTitle>
          <DialogContent>                  
            <TextField value={newName} onChange={handleChangeName} error={Boolean(errorName)} helperText={errorName}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenRename(false)}>{uxEditor.text_Cancel}</Button>
            <Button onClick={handleRenameOk} disabled={Boolean(errorName)}>{uxEditor.text_Rename}</Button>
          </DialogActions>
        </Dialog>

      </ButtonGroup>
    );
  }

  ViewUxTemplateActions = (props) => {
    const uxEditor = this;
    const theme = useTheme();        
    
    if (props.noMenu) return null;
    if (!props.uxTemplate) return null;
    const typeUx = Boolean(props.uxTemplate.default === 'y') ? uxEditor.text_Default : Boolean(props.uxTemplate.temporary) ? uxEditor.text_Temporary : null;

    //console.log('... ViewUxTemplateActions ...', props)
    return (      
      <Stack direction='column' justifyContent="flex-start" alignItems='flex-start' spacing={1} sx={{width: '100%'}}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} sx={{width: '100%'}}>
          <uxEditor.ViewUxTemplateSaveDelete {...props}/>
          <Stack flex={1} direction='column' justifyContent="center" alignItems="center">
            <Typography>{props.uxTemplate.name || ''}</Typography>
            {typeUx && <Typography variant='subtitle2' color={theme.palette.text.disabled}>{typeUx}</Typography>}
          </Stack>
          <uxEditor.ViewUxTemplateNameList {...props}/>
        </Stack>          
      </Stack>      
    )
  }
  
  ViewUxTemplate = (props) => {
    const uxEditor = this;    
    const refHeader = React.useRef(null);
    const [openTab, setOpenTab] = React.useState(0);    
    const tab = props.tabs?.[openTab] || null;
    const {dateTimeStamp, setUxTemplateUpdate} = useStateUxTemplate(tab.types);

    const uxTemplate = React.useMemo(() => {
      if (tab.getUxTemplate) return tab.getUxTemplate();
      return {name: '', body: {}};
    }, [tab, dateTimeStamp])
    
    this.updateUxTemplate = React.useCallback(() => {
      uxTemplate.lastUpdate = toDateTimeStamp(new Date());      
      return uxTemplate;
    }, [uxTemplate, tab])

    const handleClose = (event) => {
      if (props.onClose) props.onClose();
    }

    const handleChangeTab = (event, newTab) => setOpenTab(newTab);
  

    const handleReset = (event) => {
      if (!tab) {
        console.log('== Error === ViewUxTemplate empty tab', openTab);
        return
      }

      try {
        tab.onReset();
      } catch (error) {
        console.log('== Error === ViewUxTemplate Reset', error);
      }
      
      setUxTemplateUpdate(props.types);
    }

    const icon = "fa-solid fa-paintbrush";
    const resetIcon = 'fa-solid fa-arrows-rotate';
  
    return (
      <Bs4Dialog
        open={props.open}
        hideBackdrop
        onClose={() => props.onClose ? props.onClose() : null}
        refHeader={refHeader}
      >
        <DialogTitle ref={refHeader} sx={{touchAction: 'none'}}>
          <Stack ref={refHeader} width='100%' direction='row' justifyContent="space-between" alignItems="center">            
            <Stack direction='row' justifyContent='flex-start'  alignItems="center" spacing={1}>
              <i className='fa-solid fa-paintbrush'/>
              <Typography variant='h6'>{uxEditor.text_Visual_editor}</Typography>
            </Stack>            
            <Stack direction='row' justifyContent='flex-start'  alignItems="center" spacing={1}>
              {props.tabs?.[openTab]?.onReset && <IconButton edge='start' onClick={handleReset}><i className={resetIcon}/></IconButton>}                 
              <IconButton edge='end' onClick={handleClose}><CloseIcon/></IconButton>
            </Stack>
          </Stack>            
          <Tabs 
            value={openTab}
            onChange={handleChangeTab} 
            indicatorColor="secondary" 
            textColor="inherit" 
            variant="scrollable"
            scrollButtons="auto"
          >
            {(props?.tabs || []).map((tab, index) => <Tab key={index} label={index > 1 ? uxEditor.text_Page : tab.label}/>)}
          </Tabs>
        </DialogTitle>
        <DialogContent >          
          {(props.tabs || []).map((tab, index) => {
            tab.bs4KartotekaId = props.bs4KartotekaId;
            tab.optionId = props.optionId;
            // console.log('...ux tab...', tab);
            return (
              <TabPanel key={index} value={openTab} index={index}>
                <tab.Content />
              </TabPanel>
            )
          })}
        </DialogContent>
        <DialogActions disableSpacing>
          <uxEditor.ViewUxTemplateActions {...tab} uxTemplate={uxTemplate} noMenu={props.noMenu}/>
        </DialogActions>
      </Bs4Dialog>
    )
  }  
}

//getUxTemplate              (defaultUxTemplate, 0       , id  , 'Main'   );
export const getUxTemplate = (defaultUxTemplate, pagetype, id, classId) => {    
  const defaultUxTemplateCopy = JSON.parse(JSON.stringify(defaultUxTemplate))    
  defaultUxTemplateCopy.id = defaultUxTemplateCopy.name+'_'+defaultUxTemplateCopy.class+'_'+pagetype+'_'+classId;
  
  //Czy istnieje dedykowany (id) 'uxTemplate' ?
  const uxTemplate = Bs4UxTemplates.getUxTemplate(defaultUxTemplateCopy.class, pagetype, id);
  if (uxTemplate) {
    uxTemplate.body = deepmerge(defaultUxTemplateCopy.body, uxTemplate.body);
    // console.log('...getUxTemplate...', uxTemplate.name, uxTemplate);
    return uxTemplate;
  }
  
  //Czy wcześniej został utworzony Temporary 'uxTemplate' ?
  const uxTemplateTemporary = Bs4UxTemplates.getUxTemplate(defaultUxTemplateCopy.class, pagetype, defaultUxTemplateCopy.id);
  if (uxTemplateTemporary) {
    // console.log('...getUxTemplate...Temporary', uxTemplateTemporary);
    return uxTemplateTemporary;
  }

  if (id !== UXTEMPLATE_NEW) {
    //Czy istnieje default 'uxTemplate' ?
    const uxTemplateDefault = Bs4UxTemplates.getDefaultUxTemplate(defaultUxTemplateCopy.class, pagetype);
    if (uxTemplateDefault) {
      uxTemplateDefault.body = deepmerge(defaultUxTemplateCopy.body, uxTemplateDefault.body);
      // console.log('...getUxemplate...Default', uxTemplateDefault);
      return uxTemplateDefault;    
    }
  }
    
  defaultUxTemplateCopy.pagetype = pagetype;
  defaultUxTemplateCopy.name = '';
  defaultUxTemplateCopy.temporary = true;
  Bs4UxTemplates.addUxTemplate(defaultUxTemplateCopy);  
  // console.log('...getUxTemplate...new..Temporary', defaultUxTemplateCopy);
  return defaultUxTemplateCopy;
}